import {Injectable} from '@angular/core';
import {UserPreferencesModelService} from '../Session/user-preferences-model.service';
import {FavoriteWidgetDto} from '../../../Models/Widgets/favorite-widget.interface';
import {toFavoriteWidgets} from '../../../Shared/Utils/favorites.utils';

@Injectable({
  providedIn: 'root'
})
export class FavoritesWidgetsService extends UserPreferencesModelService<FavoriteWidgetDto> {

  tableName = 'yu_v3_favorites_widgets';

  /**
   * Conserva solo el identificador y la columna elegida por el usuario
   *
   */
  protected mapLegacyItem(item: any): FavoriteWidgetDto {
    return toFavoriteWidgets([item])[0];
  }

}
